import {defineStore} from 'pinia'
import { defaultComponentsData, DRAWING_STATE, FLOOR_STATE } from '../studio/constants'
import { main } from '../../main';
import studioDataService from '../../services/studioDataService';
import appMode from '../../services/appMode';

export const useStudioStore = defineStore('studioStore', {
    state : () => ({
        currentAppState: FLOOR_STATE,
        basePolygonDrawn: false,
        atleast3PointsDrawn: false,
        anyPointsDrawn: false,
        obstructionPlacedInScene: false,
        undoEnabled : false,
        redoEnabled : false,
        zoomValue : 3,
        openObstructionHeight:false,
        obstructionHeight:0,
        obstructionType:null,
        isObstructionSelected:false,
        infoFormData:{
            floorValue: null,
            supply_phase: 'Single Phase',
            tariff_rate: 7,
            monthly_bill: null,
            sanction_load: null,
          },
          gifBtnToggle: false,
          rotationValue:90,
          selectedPanel: null,
          selectedInverter: null,
          inverterQuantity: 1,
    }),
    actions: {
        OPEN_OBSTRUCTION_HEIGHT(status){
            this.openObstructionHeight=status;
this.atleast3PointsDrawn=false;
        },
        SET_OBSTRUCTION_HEIGHT(height){
            this.obstructionHeight=height;
            this.isObstructionSelected=true;
        },
        SET_OBSTRUCTION_TYPE(type){
            this.obstructionType=type;
        },
        UPDATE_INFORMATION_FORM(formData){
            this.infoFormData=formData;
        },
        SET_INFORMATION_FORM_DATA_STORE() {
              this.currentAppState= DRAWING_STATE;
            if (this.currentAppState === DRAWING_STATE) {
              if(!this.basePolygonDrawn){
                main.app.config.globalProperties.$stageInstance.newPolygonModel(this.infoFormData.floorValue);
              }
              else {
                main.app.config.globalProperties.$stageInstance.polygonModel.updateHeightOnFloorChange(this.infoFormData.floorValue);
                main.app.config.globalProperties.$stageInstance.floorValue = this.infoFormData.floorValue;
            }
            }
            this.setFloorValueInDataService(this.infoFormData);
            this.setAppStateInDataService(DRAWING_STATE);
            this.gifContent = this.gifContentForDrawing;
            this.gifBtnToggle = true;
          },
          setFloorValueInDataService(infoData = 0) {
            if (!appMode.isAppMode()) {
                const componentJSON = localStorage.getItem('componentData')
                    ? JSON.parse(localStorage.getItem('componentData'))
                    : defaultComponentsData();
                componentJSON.floorValue = infoData?.floorValue || 0;
                componentJSON.infoData = infoData;
                localStorage.setItem('componentData', JSON.stringify(componentJSON));
                const rawStageData = localStorage.getItem('stageData');
                if (rawStageData) {
                    const stageData = JSON.parse(rawStageData);
                    stageData.floorValue = infoData?.floorValue || 0;
                    localStorage.setItem('stageData', JSON.stringify(stageData));
                }
                return;
            }
            studioDataService.setInfoFormData({ ...(studioDataService.getInfoFormData()), ...infoData });
            const stageData = studioDataService.getStageData();
            stageData.floorValue = infoData?.floorValue || 0;
            studioDataService.setStageData(stageData);
          },
          setAppStateInDataService(appState = FLOOR_STATE) {
            studioDataService.setCurrentAppState(appState);
          },
          SET_SELECTED_PANEL(panel) {
            this.selectedPanel = panel;
          },
          SET_SELECTED_INVERTER(inverter) {
            this.selectedInverter = inverter;
          },
          SET_INVERTER_QUANTITY(qty) {
            this.inverterQuantity = qty;
          },
    }
})